import { localize } from "../../i18n";
import { STRING } from "../../i18n/base";
import { LENGTH_UNIT, UNIT_METHOD, WEIGHT_UNIT } from "../../context/constants";
import { configInit } from "../../context/constants";

const getConfig = (name) => {
  let config = {};
  configInit.steps.forEach((step) => {
    if (step.id === name) {
      // step.config.neckOptional = false;
      config = step.config;
    }
  });
  return config;
};

export const validateGenderStep = (profile, product_gender) => {
  if (product_gender && product_gender !== "all" && profile.gender != product_gender) {
    return false;
  }

  if (getErrorHeight(profile.height, profile.unit)) {
    return false;
  }

  if (getErrorWeight(profile.weight, profile.unit)) {
    return false;
  }

  if (getErrorAge(profile.age)) {
    return false;
  }

  if (getErrorGender(profile.gender)) {
    return false;
  }

  if (getErrorNeck(profile.neck, profile.unit, profile.gender)) {
    return false;
  }

  return true;
};

export const getErrorHeight = (height, unit) => {
  const measure_range =
    configInit.product.business.config.interview.measure_range;

  if (!height) {
    return localize(STRING.REQUIRED, {
      fieldName: STRING.HEIGHT,
    });
  } else if (
    height > measure_range.height[1] ||
    height < measure_range.height[0]
  ) {
    const error =
      unit === UNIT_METHOD.METRIC ? (
        <>
          {localize(STRING.RANGE, {
            fieldName: STRING.HEIGHT,
            min: `${measure_range.height[0]}${LENGTH_UNIT.CM}`,
            max: `${measure_range.height[1]}${LENGTH_UNIT.CM}`,
          })}
        </>
      ) : (
        <>
          {localize(STRING.RANGE, {
            fieldName: STRING.HEIGHT,
            min: `${Math.floor(measure_range.height[0] / 30.48)}${
              LENGTH_UNIT.FT
            } ${Math.floor((measure_range.height[0] % 30.48) / 2.54)}${
              LENGTH_UNIT.INCH
            }`,
            max: `${Math.floor(measure_range.height[1] / 30.48)}${
              LENGTH_UNIT.FT
            } ${Math.floor((measure_range.height[1] % 30.48) / 2.54)}${
              LENGTH_UNIT.INCH
            }`,
          })}
        </>
      );
    return error;
  }
  return false;
};

export const getErrorWeight = (weight, unit) => {
  const measure_range =
    configInit.product.business.config.interview.measure_range;

  if (!weight) {
    return localize(STRING.REQUIRED, {
      fieldName: STRING.WEIGHT,
    });
  } else if (
    weight > measure_range.weight[1] ||
    weight < measure_range.weight[0]
  ) {
    const error =
      unit === UNIT_METHOD.METRIC ? (
        <>
          {localize(STRING.RANGE, {
            fieldName: STRING.WEIGHT,
            min: `${measure_range.weight[0]}${WEIGHT_UNIT.KG}`,
            max: `${measure_range.weight[1]}${WEIGHT_UNIT.KG}`,
          })}
        </>
      ) : (
        <>
          {localize(STRING.RANGE, {
            fieldName: STRING.WEIGHT,
            min: `${Math.floor(measure_range.weight[0] / 2.205)}${
              WEIGHT_UNIT.POUNDS
            }`,
            max: `${Math.floor(measure_range.weight[1] / 2.205)}${
              WEIGHT_UNIT.POUNDS
            }`,
          })}
        </>
      );
    return error;
  }
  return false;
};

export const getErrorNeck = (neck, unit, gender) => {
  const range = configInit.product.business.config.interview.measure_range.neck;
  const config = getConfig("Gender");
  if (config?.neckOptional && !neck) return false;

  if (["all", "male", "female"].includes(config?.askNeck)) {
    if (config?.askNeck === "female" && config?.askNeck === gender) {
      // return false;
    } else if (config?.askNeck === "male" && config?.askNeck === gender) {
      // return false;
    } else {
      return false;
    }
  } else {
    return false;
  }

  if (!neck) {
    return localize(STRING.REQUIRED, {
      fieldName: STRING.NECK,
    });
  } else if (neck > range[1] || neck < range[0]) {
    const error =
      unit === UNIT_METHOD.METRIC
        ? localize(STRING.RANGE, {
            fieldName: STRING.WEIGHT,
            min: `${range[0]}${LENGTH_UNIT.CM}`,
            max: `${range[1]}${LENGTH_UNIT.CM}`,
          })
        : localize(STRING.RANGE, {
            fieldName: STRING.WEIGHT,
            min: `${Math.floor(range[0] / 2.205)}${LENGTH_UNIT.INCH}`,
            max: `${Math.floor(range[1] / 2.205)}${LENGTH_UNIT.INCH}`,
          });
    return error;
  }
  return false;
};

export const getErrorAge = (age) => {
  const measure_range =
    configInit.product.business.config.interview.measure_range;

  const config = getConfig("Gender");

  if (config?.ageOptional) return false;

  const newAge = Number(age);
  if (newAge === 0 || !newAge) {
    return localize(STRING.REQUIRED, {
      fieldName: STRING.AGE,
    });
  } else if (newAge > measure_range.age[1] || newAge < measure_range.age[0]) {
    return localize(STRING.RANGE, {
      fieldName: STRING.AGE,
      min: `${measure_range.age[0]}`,
      max: `${measure_range.age[1]}`,
    });
  }
  return false;
};

export const getErrorGender = (gender) => {
  if (!gender) {
    return localize(STRING.REQUIRED, {
      fieldName: localize(STRING.GENDER),
    });
  }
  return false;
};
